import {Component,Inject, Input} from 'ng-metadata/core';



import { VirtualBrowseService, VirtualBrowseItem, IVirtualBrowseApiParams, IVirtualBrowseObject} from './virtualBrowse.service';
import {SmoothScrollUtil} from "../../nddUtils/smoothScrollUtil.service";
import {ConfigurationUtil} from '../../nddUtils/configurationUtil.service';
import {PrimoResponse} from '../../infra/dataStructures/PrimoResponses/doc.interfcae';
import {beacon, PrimolyticsService} from "../../analytics/primolytics.service";
import { getRemoveDuplicateVirtualBrowseCustomerParameter } from '../../appConfig/appConfigForward';


const findIndex= require('lodash/findIndex');
const uniqBy = require('lodash/uniqBy');
const get= require('lodash/get');
const differenceBy = require('lodash/differenceBy');
const START_INDEX= 50;
const ITEM_WIDTH= 110; //This is hard coded also in html under md-item-size. No way around this at the moment

@Component({
selector: 'prm-virtual-browse',
templateUrl: 'components/search/virtualBrowse/virtual-browse.html',
})



export class PrmVirtualBrowse{
    @Input() item: PrimoResponse.IDoc;
    private dynamicVirtualBrowseItems: DynamicVirtualBrowseItems;
    private scrollElement: JQuery;
    private scrollDirection: string;
    private clickTimeOut;
    private CLICK_TIME= 200;
    private interval;
    private intervalCounter: number;
    private distance: number;
    private INITIAL_DISTANCE= 3;
    private LEFT= 'LEFT';
    private RIGHT= 'RIGHT';
    private nextBeaconCalledOnce: boolean = false;
    private previousBeaconCalledOnce: boolean = false;
    private KEY_CODE= {
        COMMA: 188,
        SEMICOLON : 186,
        ENTER: 13,
        ESCAPE: 27,
        SPACE: 32,
        PAGE_UP: 33,
        PAGE_DOWN: 34,
        END: 35,
        HOME: 36,
        LEFT_ARROW : 37,
        UP_ARROW : 38,
        RIGHT_ARROW : 39,
        DOWN_ARROW : 40,
        TAB : 9,
        BACKSPACE: 8,
        DELETE: 46
    };
    private MAX_DISTANCE= 20;
    private focusedIndex = START_INDEX;
    private isListFocused: boolean= false;

    constructor(private primolyticsService: PrimolyticsService,
                private virtualBrowseService: VirtualBrowseService,
                @Inject('$mdPanel') private $mdPanel: ng.material.IPanelService,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                @Inject('$element') private $element: ng.IAugmentedJQuery,
                @Inject('$interval') private $interval: ng.IIntervalService,
                private smoothScrollUtil: SmoothScrollUtil,
                private configurationUtil : ConfigurationUtil) {
        this.scrollElement= angular.element(document.querySelector("#prm-virtual-browse .md-virtual-repeat-scroller"));
//        this.scrollElement.css('overflow', 'hidden'); //TODO: this line seems to break the virtual browse built in touch support. Maybe use a media query here?
        if ($element[0].addEventListener) { //the following lines add event listeners to support mouse wheel scrolling
            // IE9, Chrome, Safari, Opera
            $element[0].addEventListener("mousewheel", (e)=>{this.mouseWheelHandler(e)}, false);
            // Firefox
            $element[0].addEventListener("DOMMouseScroll", (e)=>{this.mouseWheelHandler(e)}, false);
        }
    }

    ngOnInit(){
        this.dynamicVirtualBrowseItems= new DynamicVirtualBrowseItems(this.item, this.virtualBrowseService, this.scrollElement, this.configurationUtil);
    }

    get currentIndex(){
        return this.dynamicVirtualBrowseItems.currentIndex;
    }

    set currentIndex(index: number){
        this.dynamicVirtualBrowseItems.currentIndex= index;
    }


    private scrollLeftMouseDown(){
        this.$interval.cancel(this.interval); //if there is a scrolling action in progress cancel it
        this.intervalCounter=0;
        this.distance= this.INITIAL_DISTANCE;
        this.scrollDirection= this.LEFT;
        this.clickTimeOut= this.$timeout(()=>{this.interval= this.$interval(()=>{this.scrollList()}, 5);},this.CLICK_TIME);

    }


     private scrollRightMouseDown(){
        this.$interval.cancel(this.interval); //if there is a scrolling action in progress cancel it
         this.intervalCounter=0;
         this.distance= this.INITIAL_DISTANCE;
         this.scrollDirection= this.RIGHT;
         this.clickTimeOut= this.$timeout(()=>{this.interval= this.$interval(()=>{this.scrollList()}, 5);},this.CLICK_TIME);
     }

    private previous(event){
        if(event.which === 13) {
            this.scrollListWithClick(this.LEFT);
        }
    }

    private next(event){
        if(event.which === 13) {
            this.scrollListWithClick(this.RIGHT);
        }
    }

    private scrollListWithClick(direction){
        this.$interval.cancel(this.interval);
        this.scrollDirection = direction;
        this.smoothScrollClick();
    }


    private focusSupport(e) {
        let listElements= angular.element(e.target).parent().children();
        listElements.attr('tabindex', -1);

        if (!this.isListFocused){
            switch (e.type) {
                case 'focus':
                        this.isListFocused=true;
                        if (angular.element(document.querySelector('#vBrowseid' + this.focusedIndex)).length){
                            this.smoothScrollUtil.focusOn('vBrowseid' + this.focusedIndex);
                        }
                        else{
                            let elementToFocus= listElements[Math.ceil(listElements.length/2)];
                            this.focusedIndex= Number.parseInt(elementToFocus.id.split('vBrowseid')[1]);
                            elementToFocus.focus();
                        }

                    break;
            }
        }
    };

    private focusOutSupport(e){
        this.isListFocused=false;
        let listElements= angular.element(e.target).parent().children();
        listElements.attr('tabindex', 0);
    }

    private keyDownSupport(e, virtualBrowseItem) {
        let keyCodes = this.KEY_CODE;

        switch (e.keyCode) {
            case keyCodes.UP_ARROW:
            case keyCodes.LEFT_ARROW:
                if(this.focusedIndex > 0){ //only move focus left if we are not currently on the left most index
                    this.focusedIndex--;
                    this.smoothScrollUtil.focusOn('vBrowseid' + this.focusedIndex);
                }
                break;
            case keyCodes.DOWN_ARROW:
            case keyCodes.RIGHT_ARROW:
                if(this.focusedIndex < (START_INDEX*2 -1)){ //only move focus right if we are not currently on the right most index
                    this.focusedIndex++;
                    this.smoothScrollUtil.focusOn('vBrowseid' + this.focusedIndex);
                }
                break;
            case keyCodes.TAB:
                break;
            case keyCodes.ENTER: this.navigateToItemFullView(virtualBrowseItem); e.stopPropagation();
        }
    };


    private scrollList(){
        this.intervalCounter++;
        this.distance+=((this.intervalCounter % 38) === 0 && this.distance< this.MAX_DISTANCE? 1 : 0);

        if (this.scrollDirection === this.LEFT){
            this.scrollElement[0].scrollLeft-= this.distance;
        }
        if (this.scrollDirection === this.RIGHT){
            this.scrollElement[0].scrollLeft+= this.distance;
        }

       if (this.scrollElement[0].scrollLeft>= this.dynamicVirtualBrowseItems.rightScrollLimit || this.scrollElement[0].scrollLeft<= this.dynamicVirtualBrowseItems.leftScrollLimit){
           this.$interval.cancel(this.interval);
       }
    }

    private scrollMouseUp(){
        this.sendScrollDirectionBeacon(this.scrollDirection);
        if(this.$timeout.cancel(this.clickTimeOut)){ //If it was a quick click scroll a set distance
            this.smoothScrollClick();
        }
        else{
            this.$interval.cancel(this.interval);
        }
    }

    //easing function for smooth scrolling animation
    private easeOutExpo(t, b, c, d){
        return c * ( -Math.pow( 2, -10 * t/d ) + 1 ) + b;
    }

    private easeInOutQuart(t, b, c, d) {
        t /= d/2;
        if (t < 1) return c/2*t*t*t*t + b;
        t -= 2;
        return -c/2 * (t*t*t*t - 2) + b;
    };

    private smoothScrollClick(){
    let distanceScrolled=0;
    let clickScrollDistance= 7*(this.scrollElement[0].offsetWidth/10);
    if(this.scrollDirection === this.LEFT){
        clickScrollDistance= -clickScrollDistance;
    }
    let frame=0;
    let numOfFrames= 60;
    let beginningPos= this.scrollElement[0].scrollLeft;

    this.interval= this.$interval(() => {
            let newPos= this.easeInOutQuart(frame, beginningPos, clickScrollDistance, numOfFrames);
            if (newPos <= this.dynamicVirtualBrowseItems.leftScrollLimit && newPos < this.scrollElement[0].scrollLeft){
                this.$interval.cancel(this.interval);
                this.scrollElement[0].scrollLeft= this.dynamicVirtualBrowseItems.leftScrollLimit;
                return;
            }
            if (newPos >= this.dynamicVirtualBrowseItems.rightScrollLimit && newPos > this.scrollElement[0].scrollLeft){
                this.$interval.cancel(this.interval);
                this.scrollElement[0].scrollLeft= this.dynamicVirtualBrowseItems.rightScrollLimit;
                return;
            }
            frame++;
            this.scrollElement[0].scrollLeft= newPos;
            if (frame === numOfFrames){
                this.$interval.cancel(this.interval);
            }
         }, 2);
    }

    private mouseWheelHandler(e){
        e.preventDefault();
        let delta = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)));
        this.sendScrollDirectionBeacon(delta > 0 ? this.RIGHT : this.LEFT);
        if ((delta>=0 && this.isRightScrollDisabled) || (delta<=0 && this.isLeftScrollDisabled)){
            return false;
        }
        this.scrollElement[0].scrollLeft+= 30*delta;
        return false;
    }


    private navigateToItemFullView(virtualBrowseItem){
        this.sendVirtualBrowseItemBeacon(virtualBrowseItem.recordId);
        this.virtualBrowseService.navigateToItemFullView(virtualBrowseItem);
    }

    private getItemFullViewParams(virtualBrowseItem){
        return this.virtualBrowseService.getItemFullViewParams(virtualBrowseItem);
    }

    get isRightScrollDisabled(){
        if (!this.scrollElement){
            return false;
        }
        return this.scrollElement[0] && (this.scrollElement[0].scrollLeft >= this.dynamicVirtualBrowseItems.rightScrollLimit);
    }

    get isLeftScrollDisabled(){
        if (!this.scrollElement){
            return false;
        }
        if(this.dynamicVirtualBrowseItems.leftScrollLimit == undefined){
            return this.scrollElement[0] && this.scrollElement[0].scrollLeft ==0;
        }
        return this.scrollElement[0] && (this.scrollElement[0].scrollLeft <= this.dynamicVirtualBrowseItems.leftScrollLimit);
    }

    get leftFinalIndex(){
        return this.dynamicVirtualBrowseItems.leftFinalIndex;
    }

    get rightFinalIndex(){
        return this.dynamicVirtualBrowseItems.rightFinalIndex;
    }

    get dynamicVirtualBrowseItemsLength(){
        return this.dynamicVirtualBrowseItems.getLength();
    }


    public onItemInView($index, $inview, $inviewInfo){
        if ($index === this.leftFinalIndex -1){
            this.dynamicVirtualBrowseItems.leftScrollLimit= this.dynamicVirtualBrowseItems.leftScrollLimit || (this.scrollElement[0].scrollLeft - (2 * ITEM_WIDTH));
            if (this.dynamicVirtualBrowseItems.leftScrollLimit < 0){
                this.dynamicVirtualBrowseItems.leftScrollLimit = 0;
            }
        }
        if ($index === this.rightFinalIndex + 1){
            this.dynamicVirtualBrowseItems.rightScrollLimit= this.dynamicVirtualBrowseItems.rightScrollLimit || (this.scrollElement[0].scrollLeft + (2 * ITEM_WIDTH));
        }

    }

    public getStateName(){
        return this.virtualBrowseService.getStateName();
    }

    @beacon({'p':'virtualBrowse', 'op':'recordVirtualBrowse'})
    private sendVirtualBrowseItemBeacon(recordId){}

    public handleKeyUp(e){
        let keyCodes = this.KEY_CODE;
        switch (e.keyCode) {
            case keyCodes.LEFT_ARROW:
                    this.sendScrollDirectionBeacon(this.LEFT);
                break;
            case keyCodes.RIGHT_ARROW:
                    this.sendScrollDirectionBeacon(this.RIGHT);
                break; 
        }
    }

    private sendScrollDirectionBeacon(direction){
        if(!this.previousBeaconCalledOnce && direction === this.LEFT){
            this.sendPreviousInVirtualBrowseBeacon();
            this.previousBeaconCalledOnce = true;
        }else if(!this.nextBeaconCalledOnce && direction === this.RIGHT){
            this.sendNextInVirtualBrowseBeacon();
            this.nextBeaconCalledOnce = true;
        }
    }

    @beacon({'p':'virtualBrowse', 'op':'previousInVirtualBrowse'})
    private sendPreviousInVirtualBrowseBeacon(){}

    @beacon({'p':'virtualBrowse', 'op':'nextInVirtualBrowse'})
    private sendNextInVirtualBrowseBeacon(){}


//    private onSwipeRight(e){
//        this.$interval.cancel(this.interval); //if there is a scrolling action in progress cancel it
//        this.scrollDirection= this.LEFT;
//        this.smoothScrollClick();
//        return false;
//    }

//    private onSwipeLeft(e){
//        this.$interval.cancel(this.interval); //if there is a scrolling action in progress cancel it
//        this.scrollDirection= this.RIGHT;
//        this.smoothScrollClick();
//        return false;
//    }


}

class DynamicVirtualBrowseItems{
    public currentIndex: number= START_INDEX;
    private params: IVirtualBrowseApiParams;
    private virtualBrowseItems: Array<VirtualBrowseItem>;
    private numItems: number= START_INDEX*2;
    private nextTerm: string;
    private backTerm:string;
    private currentTerm: string;
    private leftLimitIndex: number;
    public leftFinalIndex: number;
    private rightLimitIndex: number;
    public rightFinalIndex: number;
    public rightScrollLimit: number;
    public leftScrollLimit: number;
    private offset: number;
    private isLoading: boolean;
    private globalOffset: number;
    private globalOffsetDirection: string;
    constructor(private item: PrimoResponse.IDoc, private virtualBrowseService: VirtualBrowseService, private scrollElement: JQuery,private configurationUtil : ConfigurationUtil){
        this.params=this.virtualBrowseService.buildRestApiInitialParams(get(this.item, 'enrichment.virtualBrowseObject',undefined),
            get(this.item, 'enrichment.bibVirtualBrowseObject',undefined), get(this.item,'pnx.control.sourcerecordid',undefined) ||get(this.item,'pnx.display.mms','undefined') );
        this.isLoading= true;
        this.virtualBrowseService.callVirtualBrowseApi(this.params).then((response)=>{this.handleResponse(response.data)});
    }

    public getLength(){
        return this.numItems;
    }

    public getItemAtIndex(index){
        if (index < this.leftFinalIndex){
            return undefined;
        }
        if (index > this.rightFinalIndex){
            return undefined;
        }
        if (index <= this.rightLimitIndex && index >= this.leftLimitIndex){
            return this.virtualBrowseItems[index- this.leftLimitIndex];
        }
        if (this.isLoading){ //if API already called don't call again
            return undefined;
        }
        if(index > this.rightLimitIndex){
            this.params.callNumber = this.nextTerm;
            this.params.bibCallNumber = this.nextTerm;
            this.params.position= 'RIGHT';
        }
        if(index < this.leftLimitIndex){
            this.params.callNumber = this.backTerm;
            this.params.bibCallNumber = this.backTerm;
            this.params.position= 'LEFT';
        }
        this.getOffsetLength(this.params.position);
        this.params.offset = this.globalOffset;
        this.isLoading= true; //set this flag to true so we don't try to call API more than once
        //after initial bulk get 20 items each api call. In Primo , bulks must be the same size.
        //before changing this value, check if results in virtual browse in primo are correct.
        this.params.numOfRecords=20;
        this.virtualBrowseService.callVirtualBrowseApi(this.params).then((response)=>{this.handleResponse(response.data)});

        return undefined;
    }



    
    //this method ignores duplicates virtual browse items. Determined by mmsId
    private noDuplicateBrowseItems(browseItems: Array<VirtualBrowseItem>) {
        const mmsId = 'recordId';
        var noDuplicate = uniqBy(browseItems, mmsId)
        return differenceBy(noDuplicate, this.virtualBrowseItems || [], mmsId);
    }
    

    private getItemsForVirtualBrowse(browseItems: Array<VirtualBrowseItem>) {
        return this.configurationUtil.isSuprima() && getRemoveDuplicateVirtualBrowseCustomerParameter()
                ? this.noDuplicateBrowseItems(browseItems) : browseItems;
    }
    
    private handleResponse(data){
        let virtualBrowseObject: IVirtualBrowseObject= this.virtualBrowseService.parseVirtualBrowseApiResponse(data);
        let items = this.getItemsForVirtualBrowse(virtualBrowseObject.virtualBrowseItems);
        switch(this.params.position){
            case 'CENTER':
               let itemMmsId = this.params.mmsId;
                let centerIndex= findIndex(items, (item: VirtualBrowseItem)=>{return item.recordId.includes(itemMmsId)});
                if (centerIndex > -1){
                    items[centerIndex].isSelectedRecord= true; //set the boolean for the current item who's full view is open
                }
                else{
                    centerIndex= Math.floor(items.length/2);
                }
                this.rightLimitIndex= START_INDEX + items.length- centerIndex
                this.leftLimitIndex= START_INDEX - centerIndex;
                this.virtualBrowseItems= items;
                this.currentIndex= this.calculateStartIndex(centerIndex, items.length);
                this.nextTerm= virtualBrowseObject.nextTerm;
                if(!this.nextTerm){
                    this.rightFinalIndex= this.rightLimitIndex - 1;
                }
                this.backTerm= virtualBrowseObject.backTerm;
                if(!this.backTerm){
                    this.leftFinalIndex= this.leftLimitIndex;
                }
                break;
            case 'RIGHT':
                this.rightLimitIndex= this.rightLimitIndex + items.length;
                this.nextTerm= virtualBrowseObject.nextTerm;
                if(!this.nextTerm){
                    this.rightFinalIndex= this.rightLimitIndex - 1;
                }
                this.virtualBrowseItems= this.virtualBrowseItems.concat(items);
                break;
            case 'LEFT':
                this.leftLimitIndex= this.leftLimitIndex - items.length;
                this.backTerm= virtualBrowseObject.backTerm;
                if(!this.backTerm){
                    this.leftFinalIndex= this.leftLimitIndex;
                }
                this.virtualBrowseItems= this.configurationUtil.getBackendSystem() === 'suprima' ? items.reverse().concat(this.virtualBrowseItems) : items.concat(this.virtualBrowseItems);
        }
        this.isLoading= false; // signal that API call has finished
    }

    //the following method calculates the staring index for the virtual repeat. We want to put the selected record at the center of the list to start off.
    //We also take care of edge cases such as the lowest call number of highest call number
    private calculateStartIndex(centerIndex, numOfItems): number{
        let numOfItemsInViewPort= Math.floor(this.scrollElement[0].offsetWidth / ITEM_WIDTH);
        let numOfItemsLeftOfCenter= Math.floor((numOfItemsInViewPort-1)/2);
        let numOfItemsRightOfCenter= numOfItemsInViewPort- 1 -numOfItemsLeftOfCenter;
        if ((numOfItems - centerIndex)<= numOfItemsRightOfCenter){
            return START_INDEX  - numOfItemsInViewPort + (numOfItems -centerIndex) + 1;
        }
        if (centerIndex <= numOfItemsLeftOfCenter){
            return START_INDEX - numOfItemsLeftOfCenter + centerIndex;
        }
        return START_INDEX - numOfItemsLeftOfCenter;
    }

    private  getOffsetLength(direction: string) {
        let items = this.virtualBrowseItems;
        if (direction == 'RIGHT')
            this.virtualBrowseItems.reverse();
        let counter = 0;
        let edgeCallNumber = get(items, '[0].callNumber', '');
        for (let i = 1; i < items.length; i++) {
            if (items[i].callNumber == edgeCallNumber)
                counter++;
            else
                break;
        }
        if (counter == items.length-1 && direction === this.globalOffsetDirection)
            this.globalOffset = this.globalOffset + counter;
        else if (counter > 0){
            this.globalOffsetDirection = direction;
            this.globalOffset=counter;
        }
        else {
            this.globalOffset = 0;
            this.globalOffsetDirection = undefined;
        }
        if (direction == 'RIGHT')
            this.virtualBrowseItems.reverse();

    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/virtualBrowse/virtualBrowse.directive.ts